import { useAuthStore } from "@/stores/auth";
import { CoachTabStrip, type CoachTab } from "../CoachTabStrip";

export function WorkspaceHeader({
  active,
  visibleTabs,
}: {
  active: CoachTab;
  visibleTabs?: ReadonlyArray<CoachTab>;
}) {
  const club = useAuthStore((s) => s.me?.current_club);
  return (
    <header className="coach-workspace-header">
      <div className="min-w-0">
        {club?.name ? <p className="eyebrow mb-2">{club.name}</p> : null}
        <h1>Coaching Workspace</h1>
        <p className="mt-2 text-ink-muted">
          Track who needs attention, then turn moments into feedback players can
          act on.
        </p>
      </div>
      <CoachTabStrip active={active} visibleTabs={visibleTabs} />
    </header>
  );
}
